(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scentuella-reviews-marquee"] && !Shopify.designMode) return;
  try {
    
  class ScReviewsMarquee extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.scrm__viewport');
      this.lists = this.querySelector('[data-scrm-lists]');
      this.original = this.querySelector('[data-scrm-original]');
      if (!this.viewport || !this.lists || !this.original) return;

      const header = this.closest('section');
      this.toggle = header && header.querySelector('[data-scrm-toggle]');
      this.prev = header && header.querySelector('[data-scrm-prev]');
      this.next = header && header.querySelector('[data-scrm-next]');

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;

      this.onToggle = () => {
        this.userPaused = !this.userPaused;
        this.classList.toggle('is-paused', this.userPaused);
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        this.toggle.setAttribute(
          'aria-label',
          this.userPaused ? 'Play scrolling reviews' : 'Pause scrolling reviews'
        );
      };
      this.onPrev = () => this.scrollByCard(-1);
      this.onNext = () => this.scrollByCard(1);
      this.onMotionChange = () => this.build();

      if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.motionQuery.addEventListener('change', this.onMotionChange);

      // Pause while off-screen (saves battery / CPU).
      this.io = new IntersectionObserver(([entry]) => {
        this.classList.toggle('is-offscreen', !entry.isIntersecting);
      });
      this.io.observe(this);

      // Rebuild when width changes (rotation, resize, fonts loading).
      let lastWidth = 0;
      this.ro = new ResizeObserver(() => {
        const w = Math.round(this.viewport.clientWidth);
        if (w === lastWidth) return;
        lastWidth = w;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.build(), 150);
      });
      this.ro.observe(this.viewport);

      this.build();
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      clearTimeout(this.resizeTimer);
    }

    clearClones() {
      this.lists.querySelectorAll('[data-scrm-clone]').forEach((el) => el.remove());
    }

    build() {
      this.clearClones();
      const reduced = this.motionQuery.matches;
      const header = this.closest('section');

      if (reduced) {
        // Manual mode: native scroll + snap + arrows, no animation.
        this.classList.add('is-static');
        this.classList.remove('is-ready', 'is-paused');
        this.viewport.tabIndex = 0;
        this.viewport.setAttribute('role', 'region');
        this.viewport.setAttribute('aria-label', 'Customer reviews, scrollable');
        if (this.toggle) this.toggle.hidden = true;
        if (this.prev) this.prev.hidden = false;
        if (this.next) this.next.hidden = false;
        return;
      }

      this.classList.remove('is-static');
      this.viewport.removeAttribute('role');
      this.viewport.removeAttribute('aria-label');
      this.viewport.tabIndex = -1;
      if (this.toggle) this.toggle.hidden = false;
      if (this.prev) this.prev.hidden = true;
      if (this.next) this.next.hidden = true;

      const listWidth = this.original.getBoundingClientRect().width;
      const viewWidth = this.viewport.clientWidth;
      if (!listWidth || !viewWidth) return;

      // Enough copies to always fill the viewport, plus one for the seamless loop.
      const copies = Math.ceil(viewWidth / listWidth) + 1;
      for (let i = 0; i < copies; i++) {
        const clone = this.original.cloneNode(true);
        clone.removeAttribute('data-scrm-original');
        clone.setAttribute('data-scrm-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-shopify-editor-block], [id]').forEach((n) => n.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea').forEach((n) => (n.tabIndex = -1));
        this.lists.appendChild(clone);
      }

      const speed = Math.max(10, parseFloat(this.dataset.speed) || 40); // px per second
      const duration = listWidth / speed;
      this.style.setProperty('--scrm-distance', `${listWidth}px`);
      this.style.setProperty('--scrm-duration', `${duration}s`);
      this.style.setProperty('--scrm-anim-dir', this.dataset.direction === 'reverse' ? 'reverse' : 'normal');
      this.classList.add('is-ready');
    }

    scrollByCard(dir) {
      const card = this.original.querySelector('.scrm__card');
      const step = card ? card.getBoundingClientRect().width + 16 : 320;
      this.viewport.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
  }

  if (!customElements.get('sc-reviews-marquee')) {
    customElements.define('sc-reviews-marquee', ScReviewsMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
